export default String.raw`
.contact-container {
    display: flex;
    margin-bottom: 32px;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 32px;

    &__details {
        display: flex;
            width: 40%;
            padding-top: 32px;
            flex-direction: column;
            align-items: flex-start;
            gap: 24px;
            flex-shrink: 0;
    }

    .contact-info {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        padding-bottom: 24px;
        border-bottom: 1px solid $lightBorderColor;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;

        &__title {
            padding-bottom: 24px;
        }

        &__details {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            gap: 8px;
        }

        .contact-wrapper {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            gap: 8px;

            &__details {
                display: flex;
                flex-direction: column;
            }

            a {
                color: inherit;
            }
        }
    }

    .additional-info {
        border: none;
    }

    &__form {
        width: 50%;
        box-sizing: border-box;
        padding: 24px;
        border-radius: 12px;
        box-shadow: 0px 0px 4px 0px $dropContainerShadowColor;
        background-color: $bgColor;
        color: $primaryColorFont;
        height: fit-content;

        &__header {
            padding-bottom: 40px;
        }
    }

    .primary-action-button {
        width: 100%;
    }
}

.map-container {
    width: 100%;
    float: right;

    .map {
        border-radius: 12px;
        height: 500px;
        width: 100%;
    }
}
`